import { createConstants } from '../../utils';

export default createConstants('SHOW_MESSAGE', 'HIDE_MESSAGE');
